import React from 'react';

import {
  TIME_ZONES,
  TIME_ZONES_ORDER,
} from 'utils/constants';
import FormSelect from '../FormSelect';

const TimeZoneSelect = ({
  name = 'Timezone',
  id = 'timezone-select',
  timezone,
  onChange,
  labelHidden,
  showSearch = true,
}) => {
  return (
    <FormSelect
      name={name}
      id={id}
      value={timezone}
      onChange={onChange}
      showSearch={showSearch}
      labelHidden={labelHidden}
    >
      {TIME_ZONES_ORDER.map((option, index) => (
        <optgroup label={option.value}
          key={`option_${index}`}
        >
          {TIME_ZONES.filter((tz) => tz.group === option.value).map(
            (optionTZ, indexTZ) => (
              <option
                value={optionTZ.value}
                key={`optionTZ_${option.value}_${indexTZ}`}
              >
                {optionTZ.label}
              </option>
            ),
          )}
        </optgroup>
      ))}
    </FormSelect>
  );
};

export default TimeZoneSelect;
